import { useEffect, useState } from 'react';
import './MarketPlace.css';
import { AnnouncementProduct } from './AnnouncementProduct';
import {
  getDocument,
  getReaderDocument,
  updateDocument,
} from '../../firebase-functions/database';
import { toast, ToastContainer } from 'react-toastify';
import { RobuxProduct } from './RobuxProduct';
import { auth } from '../../firebase-functions/config';

const RobuxTab = ({ readerId, readerProfile }) => {
  const [items, setItems] = useState([]);
  const [checkoutItemId, setCheckoutItemId] = useState();
  const [checkoutItem, setCheckoutItem] = useState();
  const [discount, setDiscount] = useState(0);
  const [coupons, setCoupons] = useState();
  const [coupon, setCoupon] = useState();

  useEffect(() => {
    setCoupons(readerProfile.coupons || []);
    getDocument('utils', 'robux').then((resLoad) => {
      if (!resLoad.success) {
        toast.error("Couldn't load");
        return;
      }
      setItems(resLoad.data.items);
    });
  }, []);

  useEffect(() => {
    if (!checkoutItemId) {
      setCheckoutItem();
      return;
    }
    setCheckoutItem(items.find((i) => i.id === checkoutItemId));
  }, [checkoutItemId]);

  const handleCheckout = () => {
    const total = Math.round(
      checkoutItem.price - (checkoutItem.price * discount) / 100,
    );

    getDocument('demoReaders', readerId).then((resReader) => {
      if (!resReader.success) {
        toast.error("Couldn't load the reader info");
        return;
      }
      let newReaderData = resReader.data;
      const currentGold = newReaderData.stars || 0;
      const goldDeduction = newReaderData.starDeduction || 0;

      const totalBalance = currentGold - goldDeduction;

      if (total > totalBalance) {
        toast.error('Insufficient funds');
        return;
      }

      getDocument('utils', 'robux').then((resRobux) => {
        if (!resRobux.success) {
          toast.error("couldn't get the Market Data");
          return;
        }
        let newItemsData = resRobux.data.items;
        let newTransactionHistory = resRobux.data.transactionHistory;

        if (!newItemsData.find((i) => i.id === checkoutItem.id)) {
          toast.error('Sorry, the item is already sold!');
          return;
        }

        if (coupon) {
          if (!newReaderData.coupons.find((cp) => cp.id === coupon.id)) {
            toast.error('Sorry, your coupon has already expired!');
            setCoupons(newReaderData.coupons || []);
            setCoupon();
            return;
          }

          newReaderData.coupons = newReaderData.coupons.filter(
            (cp) => cp.id !== coupon.id,
          );
          setCoupons(newReaderData.coupons.filter((cp) => cp.id !== coupon.id));
        }

        if (!newReaderData.robux) {
          newReaderData.robux = checkoutItem.robux * -1;
        } else {
          newReaderData.robux = newReaderData.robux - checkoutItem.robux;
        }

        if (!newReaderData.starDeduction) {
          newReaderData.starDeduction = total;
        } else {
          newReaderData.starDeduction = newReaderData.starDeduction + total;
        }

        const newTransactionItem = {
          robux: checkoutItem.robux,
          type: 'robux purchase',
          id: checkoutItem.id,
          price: checkoutItem.price,
          discount: discount,
          total: total,
          dateCreated: checkoutItem.dateCreated,
          datePurchased: new Date(),
          owner: {
            id: newReaderData.id,
            name: newReaderData.name,
          },
        };

        newItemsData = newItemsData.filter((it) => it.id !== checkoutItem.id);
        newTransactionHistory.push(newTransactionItem);

        updateDocument(
          'utils',
          'robux',
          {
            items: newItemsData,
            transactionHistory: newTransactionHistory,
          },
          auth.currentUser,
        ).then((resUpdateUtils) => {
          if (!resUpdateUtils.success) {
            toast.error(
              "couldn't update the marketplace data. Something went wrong.",
            );
            return;
          }
          updateDocument(
            'demoReaders',
            readerId,
            newReaderData,
            auth.currentUser,
          ).then((resUpdateUser) => {
            if (!resUpdateUser.success) {
              toast.error(
                "Couldn't update Your Data, please contact the teacher",
              );
              return;
            }
            toast.success('Purchase Complete');
            setItems(newItemsData);
          });
        });
      });
    });
  };

  return (
    <div className='market-place-category-robux'>
      <ToastContainer key={2} />
      <div className='market-place-category'>
        <h3>Robux</h3>
      </div>

      <div className='market-robux-category-outer'>
        <div className='market-place-category-items market-place-robux-items'>
          {items
            .sort((b, a) => a.dateCreated.toDate() - b.dateCreated.toDate())
            .map((item) => (
              <RobuxProduct
                key={item.id}
                id={item.id}
                price={item.price}
                robux={item.robux}
                dateCreated={item.dateCreated}
                setCheckoutItem={setCheckoutItemId}
              />
            ))}
        </div>
        {checkoutItem && (
          <div className='checkout-robux-container'>
            <div className='checkout-robux-main'>
              <h2>{checkoutItem.robux} robux</h2>
              <p
                style={{
                  textDecoration: discount > 0 ? 'line-through' : 'none',
                  color: discount > 0 ? '#f555' : '#fff',
                }}>
                {checkoutItem.price} gold
              </p>
              {discount > 0 && (
                <p>
                  {Math.round(
                    checkoutItem.price - (checkoutItem.price * discount) / 100,
                  )}
                </p>
              )}
            </div>
            <div className='checkout-robux-coupons'>
              <p>Coupons</p>

              {coupons && coupons.length > 0 ? (
                <>
                  {coupon ? (
                    <button
                      className='checkout-robux-coupon'
                      onClick={() => {
                        setCoupon();
                        setDiscount(0);
                      }}>
                      {coupon.value}% off
                    </button>
                  ) : (
                    <div className='checkout-robux-coupons-container'>
                      {coupons.map((cp) => (
                        <button
                          key={cp.id}
                          className='checkout-robux-coupon'
                          onClick={() => {
                            setCoupon(cp);
                            setDiscount(cp.value);
                          }}>
                          {cp.value}% off
                        </button>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <sub style={{ height: '40px', margin: '20px', color: '#ccc' }}>
                  None
                </sub>
              )}
            </div>

            {coupon && <div className='checkout-final-price'></div>}

            <div className='checkout-robux-buttons'>
              <button
                className='checkout-robux-button-cancel'
                onClick={() => {
                  setCheckoutItemId();
                  setCheckoutItem();
                }}>
                cancel
              </button>
              <button
                className='checkout-robux-button-proceed'
                onClick={handleCheckout}>
                proceed
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export const MarketPlace = ({ readerId, setToggleShop, setNewLocalRead }) => {
  const tabs = [
    // "Magic Items",
    'Themes',
    'Robux',
    // "Inventory",
    'Close',
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [balance, setBalance] = useState(null);
  const [readerProfile, setReaderProfile] = useState(null);
  const [readerAnnouncementItems, setReaderAnnouncementItems] = useState([]);

  useEffect(() => {
    getDocument('demoReaders', readerId).then((res) => {
      if (!res.success) {
        toast.error('something went wrong');
        console.error(res);
        return;
      }

      const currentGold = res.data.stars || 0;
      const goldDeduction = res.data.starDeduction || 0;
      setReaderProfile(res.data);

      setBalance(currentGold - goldDeduction);
    });

    getDocument('utils', 'readingAnnouncements').then((res) => {
      if (!res.success) {
        toast.error('Something went wrong with the Util calls!');
        return;
      }
      setReaderAnnouncementItems(res.data.items);
    });
  }, []);

  return (
    <>
      <ToastContainer key='0' />
      <div className='market-place-container' key='market-place'>
        <div className='div-market-place-tabs'>
          {tabs.map((tab) => (
            <button
              key={'tab-' + tab}
              className={
                tab === 'Close'
                  ? 'market-place-tab-button market-place-tab-button-close'
                  : activeTab === tab
                    ? 'market-place-tab-button market-place-tab-button-active'
                    : 'market-place-tab-button'
              }
              onClick={() => {
                if (tab === 'Close') {
                  setToggleShop(false);
                  return;
                }
                setActiveTab(tab);
              }}>
              {' '}
              {tab === 'Close' ? 'X' : tab}
            </button>
          ))}
        </div>
        <div className='market-place-main-container'>
          <div className='market-place-title'>
            <h2>
              Traders{' '}
              <span
                style={{
                  fontSize: '15px',
                  color: '#eeee',
                  marginLeft: '20px',
                }}>
                / {activeTab}
              </span>{' '}
            </h2>

            <div className='market-place-balance'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FIcon_HV_Resource_Gold_small.png?alt=media&token=7013f4c4-7fee-400a-af23-1fdc0d19185a'
                alt='gold icon'
              />
              <h2>{balance && balance}</h2>
            </div>
          </div>
          <div className='market-place-items-container'>
            {activeTab === 'Themes' && (
              <div className='market-place-category'>
                <h3>Reading Announcements</h3>
                <div className='market-place-category-items'>
                  {readerAnnouncementItems &&
                    readerAnnouncementItems.map((item) => {
                      return (
                        !readerProfile?.themeInventory
                          ?.map((a) => a.name)
                          ?.includes(item.name) && (
                          <AnnouncementProduct
                            key={item.id}
                            setNewLocalRead={setNewLocalRead}
                            setToggleShop={setToggleShop}
                            readerId={readerId}
                            isOwned={readerProfile?.themeInventory
                              ?.map((a) => a.name)
                              ?.includes(item.name)}
                            product={{
                              name: item.name,
                              src: item.gifUrl,
                              price: item.price,
                              audio: item.audioUrl,
                            }}
                          />
                        )
                      );
                    })}
                </div>
              </div>
            )}

            {activeTab === 'Robux' && (
              <RobuxTab readerId={readerId} readerProfile={readerProfile} />
            )}
          </div>
          <img
            src='https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fvillager%2FVillager_HV_Villager_1.png?alt=media&token=871e8fb3-816f-4ff7-bb60-13b9debbc068'
            alt=''
            className='village-woman-img'
          />
        </div>
      </div>
      <div
        className='market-place-closer'
        key='closer'
        onClick={() => {
          setToggleShop(false);
        }}>
        {' '}
      </div>
    </>
  );
};
